module.exports = __webpack_public_path__ + "media/images/course/__depo_02-36afd82c9f0b5b6bb17b19dfc4df8c9e.png";